import i18n from '@/i18n';
import {DurationType} from '@/services/graphqlHooks';

const durationType = {
  [DurationType.Hour]: i18n.t('Hour'),
  [DurationType.Day]: i18n.t('Day'),
  [DurationType.Week]: i18n.t('Week'),
} as Record<DurationType, string>;

export default durationType;
